import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Section,
  Cell,
  List,
  Avatar,
  Spinner,
} from "@telegram-apps/telegram-ui";
import { getInitDataUnsafe, isInTelegram } from "../lib/telegram.js";
import { api, signOut } from "../lib/api.js";

export default function Home() {
  const navigate = useNavigate();
  const { user: tgUser } = getInitDataUnsafe();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api("/api/v1/me").then(setMe).catch((e) => setError(e.message));
  }, []);

  const greeting = tgUser?.first_name ? `Привет, ${tgUser.first_name}` : "Привет";
  const subtitle = error
    ? `Не удалось проверить сессию: ${error}`
    : me
      ? me.is_admin
        ? `Админ · ${me.admin_airfields.map((a) => a.name).join(", ")}`
        : "С возвращением в небо"
      : "Загружаем профиль…";

  const airfieldPhoto =
    me?.admin_airfields?.length === 1 ? me.admin_airfields[0].photo_url : null;
  const avatarSrc = airfieldPhoto || tgUser?.photo_url || undefined;

  return (
    <List>
      <Section>
        <Cell multiline>
          <div className="rcf-hero">
            <div className="rcf-hero__avatar">
              {me ? <Avatar size={56} src={avatarSrc} /> : <Spinner size="m" />}
            </div>
            <div className="rcf-hero__text">
              <span className="rcf-hero__eyebrow">RCFlyers</span>
              <span className="rcf-hero__greeting">{greeting}</span>
              <span className="rcf-hero__sub">{subtitle}</span>
            </div>
          </div>
        </Cell>
      </Section>

      <Section header="Полёты">
        <Cell onClick={() => navigate("/book")} subtitle="Шаг за шагом — дата, время, модель" after="→">
          📅 Забронировать слот
        </Cell>
        <Cell onClick={() => navigate("/flights")} subtitle="Будущие и прошедшие бронирования" after="→">
          🗒 Мои полёты
        </Cell>
      </Section>

      <Section header="Профиль">
        <Cell onClick={() => navigate("/garage")} subtitle="Самолёты и коптеры" after="→">
          🛩 Мои модели
        </Cell>
        <Cell onClick={() => navigate("/profile")} subtitle="ФИО, документы, статус подтверждения" after="→">
          👤 Профиль пилота
        </Cell>
        <Cell onClick={() => navigate("/settings")} subtitle="Какие сообщения присылать" after="→">
          ⚙️ Уведомления
        </Cell>
      </Section>

      {me?.is_admin && me.admin_airfields?.length > 0 && (
        <Section header="Управление аэродромом">
          {me.admin_airfields.map((a) => (
            <Cell key={a.slug} onClick={() => navigate(`/admin/${a.slug}`)} subtitle="Брони, пилоты, документы" after="→">
              🛠 {a.name}
            </Cell>
          ))}
        </Section>
      )}

      {me?.user?.is_superadmin && (
        <Section header="Суперадмин">
          <Cell onClick={() => navigate("/superadmin")} subtitle="Пользователи, аэродромы, аудит" after="→">
            🛡 Портал управления
          </Cell>
        </Section>
      )}

      {!isInTelegram() && me && (
        <Section>
          <Cell
            onClick={() => { signOut(); navigate("/login", { replace: true }); }}
            subtitle="Удалит сессию в этом браузере"
            after="→"
          >
            🚪 Выйти
          </Cell>
        </Section>
      )}
    </List>
  );
}
